module.exports = __webpack_public_path__ + "img/ES-M-13.4add5d8c.svg";